export const FEATURE_LAUNCHED_AT = new Date('2023-12-04');
export const INITIAL_SUBS_GIVEN_AWAY = 328;
export const SUBS_GIVEN_AWAY_PER_DAY = 1;
